import React from 'react';

import styles from '../styles/downloadbuttons.module.css';
import Badge from './Badge';
import { REDIRECT_URL } from '../constants';

const { ios, android } = REDIRECT_URL

const DownloadButtons = () => (
	<div className={styles.container}>
		{/* Disabled until app is available */}
		<Badge disabled type="appstore" url={ios}/>
		<div style={{width: '10px'}}/>
		<Badge disabled type="googleplay" url={android}/>
	</div>
);

export default DownloadButtons;